import CloseIcon from '@rsuite/icons/Close';
import FlexboxGrid from 'rsuite/esm/FlexboxGrid';
import Panel from 'rsuite/esm/Panel';

export function NotFound({ message }: { message?: string }) {
    const notFoundMessage = message ? message : 'Page not found';
    return (
        <Panel bordered style={{ marginTop: 20 }}>
            <FlexboxGrid justify="center" style={{ textAlign: 'center' }}>
                <FlexboxGrid.Item>
                    <CloseIcon style={{ fontSize: '5em' }} />
                    <h1>{notFoundMessage}</h1>
                    <div>
                        As an admin, click <strong>Sync members</strong>
                    </div>
                </FlexboxGrid.Item>
            </FlexboxGrid>
        </Panel>
    );
}
